import React, { useEffect } from "react";
import { useUser } from "../hooks/useApi";
import { useNavigate } from "@reach/router";
import { getLoginResumePath } from "../features/entryFlow/entryIntentStorage";

import EntryAuthGuard from "../features/entryFlow/EntryAuthGuard";

const OnlyPublicRoute = ({ component: Component, location, ...rest }) => {
  const { logged, loginRedirect } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("OnlyPublicRoute", location.pathname);
  }, [location, rest]);

  useEffect(() => {
    if (logged) {
      navigate(
        getLoginResumePath(
          loginRedirect && loginRedirect !== "" ? loginRedirect : "/",
        ),
      );
    }
  }, [logged, loginRedirect, navigate]);

  return (
    <EntryAuthGuard>
      <Component {...rest} />
    </EntryAuthGuard>
  );
};

export default OnlyPublicRoute;
